"use client";

import { useQuery, UseQueryOptions } from "@tanstack/react-query";
import { userQueryKeys } from "./user-query-keys";
import { getUserDonationSummary, UserDonationSummaryDto } from "@/app/[locale]/(auth)/user/_api/user-reads";

/**
 * Hook to fetch user donation summary
 */
export function useUserDonationSummary(
  options?: Omit<UseQueryOptions<UserDonationSummaryDto>, "queryKey" | "queryFn">
) {
  return useQuery({
    queryKey: userQueryKeys.donationSummary(),
    queryFn: () => getUserDonationSummary(),
    staleTime: 5 * 60 * 1000, // 5 minutes - donation data updates relatively infrequently
    ...options,
  });
}